import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";

const CreditLocalPOPUP = ({ savedData = [], onAdd }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ amount: "", name: "" });

  const reset = () => setForm({ amount: "", name: "" });

  const submit = async () => {
    if (!form.amount || !form.name) return;
    const token = localStorage.getItem("authToken");
    try {
      await axios.post(
        `${API_BASE_URL}/api/creditsave`,
        {
          token,
          name: form.name,
          amount: form.amount,
        },
        { headers: { "Content-Type": "application/json" } },
      );
      if (onAdd) onAdd({ amount: form.amount, name: form.name });
      reset();
      setOpen(false);
    } catch (e) {
      // fallback to local add so user doesn't lose input
      if (onAdd) onAdd({ amount: form.amount, name: form.name });
      reset();
      setOpen(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-warning"
        onClick={() => setOpen(true)}
      >
        Add Credit
      </button>
      {open && (
        <div className="modal d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Credit</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setOpen(false)}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label>Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    value={form.amount}
                    onChange={(e) =>
                      setForm({ ...form, amount: e.target.value })
                    }
                  />
                </div>
                <div className="form-group">
                  <label>Name</label>
                  <select
                    className="form-control"
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    required
                  >
                    <option value="">Select name</option>
                    {savedData.map((i, idx) => (
                      <option key={idx} value={i.name}>
                        {i.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setOpen(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={submit}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CreditLocalPOPUP;
